module.exports = {
    layouts:
      [
        //Streams
        {
          type: 'recently_viewed_streams',
          name: 'Recently Viewed Streams',
          category: 'stream',
          description: 'Streams that were recently viewed by the user so they can pick up from exactly where they dropped off.',
          icon: ""
        },
  
        //Collections
        {
          type: 'my_collections',
          name: 'My Collections',
          category: 'collection',
          description: 'Collections created by and collaborated with the user so they can find everything they need without leaving the Hub.',
          icon: ""
        },
  
        //Assets
        {
          type: 'most_viewed_assets',
          name: 'Popular with your teams',
          category: 'asset',
          description: 'Assets with the most number of views to easily discover the ones that are a hit among your peers.',
          icon: ""
        },
        {
          type: 'recently_viewed_assets',
          name: 'Continue where you left',
          category: 'asset',
          description: 'Assets that were recently viewed by the user so they can pick up from exactly where they dropped off. ',
          icon: "",
          dimensions: '128 * 150 px'
        },
        {
          type: 'recently_added_assets',
          name: 'Recent additions to Hub',
          category: 'asset',
          description: 'Assets that were recently added to the Content Hub so nobody has to doomscroll to find the latest additions.',
          icon: ""
        },
        {
          type: 'recommended_assets',
          name: 'Recommended Assets',
          category: 'asset',
          description: 'Paperflite’s AI uses a Collaborative Filtering system to recommend Assets to a user based on similar users’ reading patterns.',
          icon: ""
        },
        {
          type: 'recently_updated_assets',
          name: 'Recently Updated Assets',
          category: 'asset',
          description: 'Assets that were recently updated / edited or changed by you and your team on the Content Hub.',
          icon: ""
        } ,
        {
          type: 'frequently_shared_assets',
          name: 'Frequently Shared Assets',
          category: 'asset',
          description: 'Assets that were most shared by your team. Your champion assets!',
          icon: ""
        }
      ]
  };
  
  